module.exports = __webpack_public_path__ + "da4a61e3cbabef230c5c7ba8458bcfe4.svg";


//////////////////
// WEBPACK FOOTER
// ./images/pharmacyIcon.svg
// module id = 40
// module chunks = 0